module.exports = __webpack_public_path__ + "static/media/img3-1.240a078b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/biosense/biomasa/img3-1.png
// module id = 2286
// module chunks = 3